<template>
  <div class="culture">
    <div class="header">
      <div class="title">企业文化</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <div class="item" v-for="item in cultureList" :key="item.id">
          <img :src="item.logo" alt="" />
          <div class="absolute">
            <div class="title">{{ item.title }}</div>
            <div class="text">
              <div>{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileculture1 from "../../../assets/about/mobileculture1.png";
import mobileculture2 from "../../../assets/about/mobileculture2.png";
import mobileculture3 from "../../../assets/about/mobileculture3.png";
import mobileculture4 from "../../../assets/about/mobileculture4.png";
import mobileculture5 from "../../../assets/about/mobileculture5.png";

export default {
  setup() {
    return reactive({
      cultureId: 1,
      cultureList: [
        {
          id: 1,
          title: "客户第一",
          text: "站在客户的立场思考问题，最终达成甚至超越客户期望",
          logo: mobileculture1,
        },
        {
          id: 2,
          title: "诚信原则",
          text: "诚信，是人们安身立命的根本，所以做人不可无诚信",
          logo: mobileculture2,
        },
        {
          id: 3,
          title: "团队至上",
          text: "好的团队精神就像冲锋的号角，激励员工勇往直前，不断战胜困难",
          logo: mobileculture3,
        },
        {
          id: 4,
          title: "敬业原则",
          text: "用专业的知识、专注的态度、平常的心态对待每件事；把事情做正确",
          logo: mobileculture4,
        },
        {
          id: 5,
          title: "创新求变",
          text: "工作中具有前瞻意识，面对变化不断尝试新方法，新思路",
          logo: mobileculture5,
        },
      ],
    });
  },
  methods: {
    cultureEnter(id) {
      this.cultureId = id;
    },
  },
};
</script>

<style scoped>
.culture {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body {
  margin-top: 16px;
}
.body .list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 24px;
}
.body .list .item {
  position: relative;
  cursor: pointer;
}
.body .list .item img {
  height: 90px;
}
.body .list .item .absolute {
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
}
.body .list .item .absolute .title {
  font-size: 14px;
  color: #fff;
}
.body .list .item .absolute .text {
  font-size: 10px;
  color: #fff;
  margin-top: 8px;
}
</style>
